import Action from '../action';

export const GET_TRANSFERKEYS = '@transfer/GET_TRANSFERKEYS';
export const GET_TRANSFERKEYS_FAIL = `${GET_TRANSFERKEYS}_FAIL`;
export const GET_TRANSFERKEYS_SUCCESS = `${GET_TRANSFERKEYS}_SUCCESS`;

export const INITIATE_ASSET_TRANSFER = '@transfer/INITIATE_ASSET_TRANSFER';
export const INITIATE_ASSET_TRANSFER_FAIL = '@transfer/INITIATE_ASSET_TRANSFER_FAIL';
export const TRANSFER_ASSETS = '@transfer/TRANSFER_ASSETS';
export const TRANSFER_ASSET_FAIL = '@transfer/TRANSFER_ASSET_FAIL';
export const TRANSFER_ASSET_SUCCESS = '@transfer/TRANSFER_ASSET_SUCCESS';

export const RESET_TRANSFERS = '@transfer/RESET_TRANSFERS';

export const getTransferKeys = () => Action(GET_TRANSFERKEYS);
export const getTransferKeysSuccess = payload => Action(GET_TRANSFERKEYS_SUCCESS, payload);
export const getTransferKeysFail = error => Action(GET_TRANSFERKEYS_FAIL, error, true);
export const initiateAssetTransfer = (assets = [], key) =>
  Action(INITIATE_ASSET_TRANSFER, {
    key,
    assets
  });
export const initiateAssetTransferFail = error => Action(INITIATE_ASSET_TRANSFER_FAIL, error, true);
export const transferAssets = (key, installations) =>
  Action(TRANSFER_ASSETS, {
    key,
    installations
  });
export const transferAssetSuccess = payload => Action(TRANSFER_ASSET_SUCCESS, payload);
export const transferAssetFail = (installationId, error) => Action(TRANSFER_ASSET_FAIL, {installationId, error}, true);
export const resetTransfers = () => Action(RESET_TRANSFERS);
